module.exports = __webpack_public_path__ + "a1740975d70985aa9e3fc1e3db2b8550.png";